// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IfaIXJyak6V6rKxybRxY{border:1px solid var(--color-grey-200)}`, "",{"version":3,"sources":["webpack://./src/components/asset-management-system/custom-views/tabs/value/steps/smart-grading-step/grading-workflow-selection.scss"],"names":[],"mappings":"AAAA,sBACI,sCAAA","sourcesContent":[".borderColor {\n    border: 1px solid var(--color-grey-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"borderColor": `IfaIXJyak6V6rKxybRxY`
};
export default ___CSS_LOADER_EXPORT___;
